import { filter, indexOf } from 'lodash';
import { getBarbers } from '../../barbers/selectors';
import { getSelectedTimeBarberRoute } from '../../times/selectors';


// eslint-disable-next-line import/prefer-default-export
export const getAvailableTimeBarbers = (state, { barberRoute, shopRoute, reservationTime }) => {
  const selected = getSelectedTimeBarberRoute(state, reservationTime);
  return filter(
    getBarbers(state, { shopRoute, barberRoute }),
    barber => indexOf(selected, barber.route) > -1
  );
};



// WEBPACK FOOTER //
// ./src/app/dynamicBooking/time/selectors.js